/** @format */
import angular from 'angular';
import _ from 'lodash';
import { ModalService } from 'sis-common';
import { CourseUnitBoxComponent } from '../courseUnit/course-unit-box/course-unit-box.component';
import { ModuleBoxComponent } from '../module/module-box/module-box.component';
import { PrerequisiteGroupEditModalComponent } from './prerequisiteGroupEditModal.component';
import prerequisiteGroupEditModalTpl from './prerequisiteGroupEditModal.tpl.html';
import { prerequisiteSelectorModule } from './prerequisiteSelector.component';

prerequisiteGroupEditModalService.$inject = ['modalService'];

export const prerequisiteGroupEditModalModule = 'sis-components.prerequisites.prerequisiteGroupEditModal';

angular
    .module(prerequisiteGroupEditModalModule, [
        prerequisiteSelectorModule,
        ModalService.downgrade.moduleName,
        ModuleBoxComponent.downgrade.moduleName,
        CourseUnitBoxComponent.downgrade.moduleName,
    ])
    .factory('prerequisiteGroupEditModal', prerequisiteGroupEditModalService)
    .controller('prerequisiteGroupEditModalController', prerequisiteGroupEditModalController)
    .component('prerequisiteGroupEditModal', {
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<',
        },
        controller: prerequisiteGroupEditModalController,
        template: prerequisiteGroupEditModalTpl,
    });

function prerequisiteGroupEditModalService(modalService) {
    return {
        open: prerequisiteGroup => modalService.open(PrerequisiteGroupEditModalComponent, { prerequisiteGroup }).result,
    };
}

function prerequisiteGroupEditModalController() {
    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.prerequisiteGroup = $ctrl.resolve.prerequisiteGroup;
    };

    $ctrl.addNewCourseUnitPrerequisite = () => {
        if (!hasUndefinedCourseUnitPrerequisite()) {
            $ctrl.prerequisiteGroup.prerequisites.push({
                courseUnitGroupId: undefined,
                type: 'CourseUnit',
            });
        }
    };

    $ctrl.addNewModulePrerequisite = () => {
        if (!hasUndefinedModulePrerequisite()) {
            $ctrl.prerequisiteGroup.prerequisites.push({
                moduleGroupId: undefined,
                type: 'Module',
            });
        }
    };

    function hasUndefinedCourseUnitPrerequisite() {
        return _.some($ctrl.prerequisiteGroup.prerequisites, { courseUnitGroupId: undefined });
    }

    function hasUndefinedModulePrerequisite() {
        return _.some($ctrl.prerequisiteGroup.prerequisites, { moduleGroupId: undefined });
    }

    $ctrl.removePrerequisite = index => {
        $ctrl.prerequisiteGroup.prerequisites.splice(index, 1);
    };

    $ctrl.doSelect = function (index, groupId) {
        if ($ctrl.prerequisiteGroup.prerequisites[index].type === 'CourseUnit') {
            $ctrl.prerequisiteGroup.prerequisites[index].courseUnitGroupId = groupId;
        } else {
            $ctrl.prerequisiteGroup.prerequisites[index].moduleGroupId = groupId;
        }
    };

    $ctrl.cancel = () => {
        $ctrl.dismiss();
    };

    $ctrl.ok = () => {
        $ctrl.prerequisiteGroup.prerequisites = _.filter(
            $ctrl.prerequisiteGroup.prerequisites,
            r => !!r.courseUnitGroupId || !!r.moduleGroupId,
        );
        $ctrl.close({ $value: $ctrl.prerequisiteGroup });
    };
}
